export default function registriesAreInUse() {
  return true;
}
